import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.StatementBalance.CreateForDealer.IRequest;
type Response = Api.Core.StatementBalance.CreateForDealer.IResponse;
type Headers = Api.Core.StatementBalance.CreateForDealer.IHeaders;
const url = '/api/DealerManagement/StatementBalance/ForDealer';
export default async function statementBalanceCreateForDealerApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
